import React from "react";

const MotorsAbout = () => {
  const brandPurple = "#7e22ce";
  const brandMagenta = "#c026d3";
  const brandCyan = "#06b6d4";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "40px 0 60px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 2. About Iconic Motors Block ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          {/* Left Collage */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "12px",
              position: "relative",
            }}
          >
            <div style={{ gridColumn: "span 2", position: "relative" }}>
              <img
                src="https://images.unsplash.com/photo-1570125909232-eb263c188f7e?auto=format&fit=crop&w=1200&q=85"
                alt="Bus Fleet"
                style={{
                  width: "100%",
                  height: "260px",
                  borderRadius: "12px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "16px",
                  right: "16px",
                  background: "#ffffff",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                  textAlign: "center",
                  border: "1px solid #f1f5f9",
                }}
              >
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    color: brandPurple,
                    display: "block",
                    lineHeight: "1.1",
                  }}
                >
                  15+
                </span>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Years Experience
                </span>
              </div>
            </div>

            <img
              src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=600&q=80"
              alt="Mechanic at work"
              style={{
                width: "100%",
                height: "140px",
                borderRadius: "10px",
                objectFit: "cover",
                display: "block",
              }}
            />
            <img
              src="https://images.unsplash.com/photo-1617814076367-b759c7d7e738?auto=format&fit=crop&w=600&q=80"
              alt="Automotive Parts"
              style={{
                width: "100%",
                height: "140px",
                borderRadius: "10px",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>

          {/* Right Text Content */}
          <div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                marginBottom: "10px",
                textTransform: "uppercase",
              }}
            >
              ✦ ABOUT ICONIC MOTORS
            </div>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Your Trusted Partner for{" "}
              <span style={{ color: brandMagenta }}>Complete Bus Care</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "24px",
              }}
            >
              At Iconic Motors, we pride ourselves on delivering top-tier
              mechanical servicing, repair, and maintenance for commercial and
              passenger buses. With our team of skilled mechanics and modern
              diagnostic equipment, we ensure your bus runs at its peak
              performance.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
                marginBottom: "28px",
              }}
            >
              {[
                "State-of-the-art diagnostic equipment",
                "Certified and experienced mechanics",
                "Genuine OEM parts guaranteed",
                "Transparent pricing with no hidden costs",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandMagenta,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>

            <div
              style={{
                display: "flex",
                gap: "40px",
                borderTop: "1px solid #e2e8f0",
                paddingTop: "24px",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "28px",
                    fontWeight: "800",
                    color: brandPurple,
                    display: "block",
                    lineHeight: "1",
                    marginBottom: "4px",
                  }}
                >
                  15+
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#64748b",
                  }}
                >
                  YEARS EXPERIENCE
                </span>
              </div>

              <div>
                <span
                  style={{
                    fontSize: "28px",
                    fontWeight: "800",
                    color: brandPurple,
                    display: "block",
                    lineHeight: "1",
                    marginBottom: "4px",
                  }}
                >
                  5000+
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#64748b",
                  }}
                >
                  HAPPY CLIENTS
                </span>
              </div>

              <div>
                <span
                  style={{
                    fontSize: "28px",
                    fontWeight: "800",
                    color: brandPurple,
                    display: "block",
                    lineHeight: "1",
                    marginBottom: "4px",
                  }}
                >
                  50+
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#64748b",
                  }}
                >
                  EXPERT MECHANICS
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ================= 3. Horizontal Stats Counter Bar ================= */}
        <div
          style={{
            background: "#ffffff",
            padding: "32px 24px",
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "12,500+", label: "Happy Customers" },
            { value: "15+", label: "Years Experience" },
            { value: "100%", label: "OEM Parts Assured" },
            { value: "24/7", label: "Roadside Assistance" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 4. Repair Steps ================= */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: brandMagenta,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            HOW WE WORK
          </span>

          <h2
            style={{
              fontSize: "32px",
              fontWeight: "800",
              margin: "8px 0 36px 0",
              color: "#0f172a",
            }}
          >
            Simple & Transparent Repair{" "}
            <span style={{ color: brandCyan }}>Steps</span>
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "20px",
            }}
          >
            {[
              {
                step: "01",
                title: "Dock & Inspection",
                desc: "Bring your bus or schedule a pickup. We conduct a thorough digital checkup.",
              },
              {
                step: "02",
                title: "Transparent Quote",
                desc: "Receive a detailed report with itemized costs before we turn a single wrench.",
              },
              {
                step: "03",
                title: "Expert Repair",
                desc: "Our certified technicians perform required repairs using 100% genuine OEM parts.",
              },
              {
                step: "04",
                title: "Quality Test & Handover",
                desc: "Rigorously road testing ensures safety before we hand back your refreshed vehicle.",
              },
            ].map((s, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "28px 20px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  textAlign: "left",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.02)",
                }}
              >
                <span
                  style={{
                    fontSize: "32px",
                    fontWeight: "800",
                    color: "#cbd5e1",
                    display: "block",
                    marginBottom: "12px",
                    lineHeight: "1",
                  }}
                >
                  {s.step}
                </span>

                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {s.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.55",
                  }}
                >
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Infrastructure Features ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              OUR INFRASTRUCTURE
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              State-of-the-Art Facility &{" "}
              <span style={{ color: brandCyan }}>Tools</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "20px",
            }}
          >
            {[
              {
                title: "Automated Diagnostic Bays",
                desc: "Computer scan ECU error codes in under 10 minutes for fast fault identification.",
              },
              {
                title: "100% OEM Spare Parts",
                desc: "We stock massive genuine manufacturer components with official warranty.",
              },
              {
                title: "Heavy Hydraulic Lifts",
                desc: "Equipped to safely lift and service commercial buses, trucks, and passenger liners.",
              },
              {
                title: "AC Waiting Lounge",
                desc: "Relax in our comfortable silent lounge with free Wi-Fi while your bus is serviced.",
              },
            ].map((infra, idx) => (
              <div
                key={idx}
                style={{
                  background: "#f8fafc",
                  padding: "24px 20px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "17px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {infra.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.55",
                  }}
                >
                  {infra.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 6. Safety Standard Light Card ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "44px 40px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "1fr auto",
            alignItems: "center",
            gap: "30px",
            marginBottom: "60px",
          }}
        >
          <div style={{ maxWidth: "680px" }}>
            <span
              style={{
                fontSize: "12px",
                color: brandMagenta,
                fontWeight: "700",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              HIGH SAFETY STANDARDS
            </span>

            <h2
              style={{
                fontSize: "28px",
                fontWeight: "800",
                margin: "10px 0 12px 0",
                color: "#0f172a",
              }}
            >
              Certified Automotive Safety & Rigorous Inspection
            </h2>

            <p
              style={{
                fontSize: "15px",
                color: "#64748b",
                lineHeight: "1.6",
                margin: 0,
              }}
            >
              Every bus repaired at our shop undergoes a strict 30+ point
              inspection checklist, ensuring complete roadworthiness, braking
              precision, and optimal safety before delivery.
            </p>
          </div>

          <div style={{ display: "flex", gap: "16px" }}>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #cbd5e1",
                padding: "20px 16px",
                borderRadius: "12px",
                textAlign: "center",
                width: "120px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "800",
                  color: brandMagenta,
                  display: "block",
                  lineHeight: "1",
                  marginBottom: "6px",
                }}
              >
                100%
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#64748b",
                }}
              >
                SAFETY CERTIFIED
              </span>
            </div>

            <div
              style={{
                background: "#ffffff",
                border: "1px solid #cbd5e1",
                padding: "20px 16px",
                borderRadius: "12px",
                textAlign: "center",
                width: "120px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                  marginBottom: "6px",
                }}
              >
                30+
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#64748b",
                }}
              >
                POINT SAFETY CHECK
              </span>
            </div>
          </div>
        </div>

        {/* ================= 7. Bottom CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #c026d3 0%, #a855f7 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#ffffff",
              }}
            >
              Ready to Give Your Bus Top Care?
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Schedule a professional inspection or book your fleet maintenance
              today with our certified mechanics.
            </p>
          </div>

          <div style={{ display: "flex", gap: "14px" }}>
            <button
              style={{
                background: "#ffffff",
                color: brandPurple,
                border: "none",
                padding: "14px 26px",
                borderRadius: "8px",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Book Appointment →
            </button>

            <button
              style={{
                background: "transparent",
                color: "#ffffff",
                border: "2px solid #ffffff",
                padding: "14px 26px",
                borderRadius: "8px",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Call Us Now
            </button>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: 1fr auto"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MotorsAbout;
